"use strict";

var scrollTarget = "";

const maxScrollAttempts = 10;

const scheduleScrollAttempt = function (callback) {
  if (typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(callback);
  } else {
    setTimeout(callback, 16);
  }
};

const scrollAttempt = function (id, attempt) {
  if (scrollTarget !== id) {
    return;
  }

  const elem = document.getElementById(id);
  if (elem) {
    elem.scrollIntoView();
    return;
  }

  if (attempt < maxScrollAttempts) {
    scheduleScrollAttempt(function () {
      scrollAttempt(id, attempt + 1);
    });
  }
};

export const jsScrollIntoView = function (id) {
  scrollTarget = id;

  return function () {
    scheduleScrollAttempt(function () {
      scrollAttempt(id, 0);
    });
  };
};
